import { Injectable } from "@angular/core";

@Injectable()
export class ProductServiceProvider {
  productObj: any = {
    quantity: 1,
    total: 0,
    product_erp_name: null,
    product_weight: "",
    product_selling_price: 0
  };

  products: any = [];
  depos: any = [];
  actual_depos: any = [];
  productResponse: any = {};

  

  constructor() {}

  clear() {
    this.productObj = {
      quantity: 1,
      total: 0,
      product_erp_name: null,
      product_weight: "",
      product_selling_price: 0
    };

    this.products = [];
    this.productResponse = {};
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product.service.ts